import { ca } from '@cian/analytics';

export const trackUpdateVacancyDateClick = (vacancyId: number) => {
  ca('event', {
    action: 'dateupdate_vacancy',
    category: 'Vacancies',
    label: String(vacancyId),
    name: 'oldevent',
  });
};
